import React, { useEffect, useState } from 'react';
import { GoogleMap, useJsApiLoader, Polygon } from '@react-google-maps/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const libraries = ['places'];

export const DeliveryZoneMap = () => {
  const [zones, setZones] = useState([]);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/config/public`);
        if (r.ok) {
          const cfg = await r.json();
          const zs = (cfg.delivery_zones || []).filter((z) => (z.points || []).length >= 3);
          setZones(zs);
        }
      } catch (e) { console.debug('zone load failed', e); }
    })();
  }, []);

  if (!isLoaded || !zones.length) return null;

  const allPoints = zones.flatMap((z) => z.points);

  const onLoad = (map) => {
    const fit = () => {
      const bounds = new window.google.maps.LatLngBounds();
      allPoints.forEach(([lat, lng]) => bounds.extend({ lat, lng }));
      map.fitBounds(bounds, 30);
    };
    window.google.maps.event.addListenerOnce(map, 'idle', fit);
    setTimeout(fit, 400);
  };

  const center = {
    lat: allPoints.reduce((s, p) => s + p[0], 0) / allPoints.length,
    lng: allPoints.reduce((s, p) => s + p[1], 0) / allPoints.length,
  };

  return (
    <div className="rounded-3xl overflow-hidden border-2 border-[#2EC4B6]/30 shadow-sm" data-testid="home-delivery-zone-map">
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '480px' }}
        center={center}
        zoom={11}
        onLoad={onLoad}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
          gestureHandling: 'cooperative',
          clickableIcons: false,
        }}
      >
        {zones.map((z, i) => (
          <Polygon
            key={i}
            paths={z.points.map(([lat, lng]) => ({ lat, lng }))}
            options={{
              fillColor: z.color || '#2EC4B6', fillOpacity: 0.18,
              strokeColor: z.color || '#FF6B35', strokeWeight: 3, clickable: false,
            }}
          />
        ))}
      </GoogleMap>
    </div>
  );
};

export default DeliveryZoneMap;
